<template>
  <ul v-if="profiles && profiles.length" class="square-social" :class="{ 'square-social-compact': compact }" aria-label="作者社媒账号">
    <li v-for="(profile,index) in visibleProfiles" :key="index"><span class="square-social-platform">{{ profile.platform }}</span><span><b v-if="profile.name">{{ profile.name }}</b><span v-if="profile.account" class="square-social-account">账号：{{ profile.account }}</span></span></li>
    <li v-if="compact && profiles.length > 1" class="square-social-more">另有 {{ profiles.length - 1 }} 个社媒账号</li>
  </ul>
</template>
<script>
export default {
  props: { profiles: { type: Array, default: () => [] }, compact: Boolean },
  computed: { visibleProfiles() { return this.compact ? this.profiles.slice(0,1) : this.profiles } }
}
</script>
